import mitt from 'mitt';

type Events = {
	'popup:open': { id: string };
	'popup:close': { id: string };
	'popup:action': { id: string; actionId: string };
	'app:key': { key: string };
	'app:popup-open': { component: unknown; id?: string; [key: string]: unknown };
	'app:popup-close': { id?: string };
	'app:popup-force-close': undefined;
};

export const eventBus = mitt<Events>();
